import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  toString30pk9tzaqopn as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  binds4rk2rn2wwzpn as binds,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  ILocalSource1zuymxsgjvvss as ILocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleCacheLocalSource3mbicvk11uh40 as SimpleCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import { ILogger102gekz4uf4a8 as ILogger } from './Shared7Punches-infrastructure-logging.mjs';
import { Clientssjxb7gh2u6y as Client } from './Shared7Punches-infrastructure-network.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(ITimeClockingSettingsAccessor, 'ITimeClockingSettingsAccessor', VOID, VOID, VOID, [1]);
initMetadataForInterface(ITimeClockingSettingsMutator, 'ITimeClockingSettingsMutator', VOID, VOID, VOID, [1]);
initMetadataForClass(TimeClockingSettingsRepository, 'TimeClockingSettingsRepository', VOID, VOID, [ITimeClockingSettingsAccessor, ITimeClockingSettingsMutator], [1, 0]);
initMetadataForInterface(ITimeClockingRemoteSource, 'ITimeClockingRemoteSource', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(TimeClockingRemoteSource, 'TimeClockingRemoteSource', VOID, VOID, [ITimeClockingRemoteSource], [0, 1]);
initMetadataForClass(TimeClockingSettings, 'TimeClockingSettings');
//endregion
function TimeClockingSettingsRepository(localSource, logger, remoteSource) {
  this.da2_1 = localSource;
  this.ea2_1 = logger;
  this.fa2_1 = remoteSource;
}
function ITimeClockingRemoteSource() {
}
function TimeClockingRemoteSource(apiClient, sessionDataProvider) {
  this.ga2_1 = apiClient;
  this.ha2_1 = sessionDataProvider;
}
function get_timeClockingModule() {
  _init_properties_TimeClockingModule_kt__c29nhp();
  return timeClockingModule;
}
var timeClockingModule;
function timeClockingModule$lambda($this$module) {
  _init_properties_TimeClockingModule_kt__c29nhp();
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = timeClockingModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(TimeClockingSettingsRepository), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  var tmp = new KoinDefinition($this$module, factory);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [getKClass(ITimeClockingSettingsAccessor), getKClass(ITimeClockingSettingsMutator)];
  binds(tmp, tmp$ret$5);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = timeClockingModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ITimeClockingRemoteSource), null, tmp2, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp9 = new TypeQualifier(getKClass(TimeClockingSettings));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = timeClockingModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(ILocalSource), tmp9, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  new KoinDefinition($this$module, factory_1);
  return Unit_instance;
}
function timeClockingModule$lambda$lambda($this$single, it) {
  _init_properties_TimeClockingModule_kt__c29nhp();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(TimeClockingSettings));
  var tmp = $this$single.q1d(getKClass(ILocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(ILogger), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(ITimeClockingRemoteSource), null, null);
  return new TimeClockingSettingsRepository(tmp, tmp_0, tmp$ret$3);
}
function timeClockingModule$lambda$lambda_0($this$factory, it) {
  _init_properties_TimeClockingModule_kt__c29nhp();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new TimeClockingRemoteSource(tmp, tmp$ret$1);
}
function timeClockingModule$lambda$lambda_1($this$single, it) {
  _init_properties_TimeClockingModule_kt__c29nhp();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('time_clocking_settings', tmp$ret$0);
}
var properties_initialized_TimeClockingModule_kt_ixj3m9;
function _init_properties_TimeClockingModule_kt__c29nhp() {
  if (!properties_initialized_TimeClockingModule_kt_ixj3m9) {
    properties_initialized_TimeClockingModule_kt_ixj3m9 = true;
    timeClockingModule = module_0(VOID, timeClockingModule$lambda);
  }
}
function ITimeClockingSettingsAccessor() {
}
function TimeClockingSettings(breakType, isBuddyPunchPreventionEnabled, isEmployeeViewTimesheetEnabled, isExternalTimeClockingEnabled, isMissingPunchAlertsEnabled, isMobilePunchEnabled, isPunchWithoutShiftEnabled, isRoleSwitchOnPunchInEnabled, isSevenPunchesEnabled, isShowCollectedTipsMobile, isTimeClockingEnabled, isTimeClockingSetup, payrollChosenDate, payrollFrequency) {
  this.ia2_1 = breakType;
  this.ja2_1 = isBuddyPunchPreventionEnabled;
  this.ka2_1 = isEmployeeViewTimesheetEnabled;
  this.la2_1 = isExternalTimeClockingEnabled;
  this.ma2_1 = isMissingPunchAlertsEnabled;
  this.na2_1 = isMobilePunchEnabled;
  this.oa2_1 = isPunchWithoutShiftEnabled;
  this.pa2_1 = isRoleSwitchOnPunchInEnabled;
  this.qa2_1 = isSevenPunchesEnabled;
  this.ra2_1 = isShowCollectedTipsMobile;
  this.sa2_1 = isTimeClockingEnabled;
  this.ta2_1 = isTimeClockingSetup;
  this.ua2_1 = payrollChosenDate;
  this.va2_1 = payrollFrequency;
}
protoOf(TimeClockingSettings).toString = function () {
  return 'TimeClockingSettings(breakType=' + this.ia2_1.toString() + ', isBuddyPunchPreventionEnabled=' + this.ja2_1 + ', isEmployeeViewTimesheetEnabled=' + this.ka2_1 + ', isExternalTimeClockingEnabled=' + this.la2_1 + ', isMissingPunchAlertsEnabled=' + this.ma2_1 + ', isMobilePunchEnabled=' + this.na2_1 + ', isPunchWithoutShiftEnabled=' + this.oa2_1 + ', isRoleSwitchOnPunchInEnabled=' + this.pa2_1 + ', isSevenPunchesEnabled=' + this.qa2_1 + ', isShowCollectedTipsMobile=' + this.ra2_1 + ', isTimeClockingEnabled=' + this.sa2_1 + ', isTimeClockingSetup=' + this.ta2_1 + ', payrollChosenDate=' + this.ua2_1 + ', payrollFrequency=' + toString(this.va2_1) + ')';
};
protoOf(TimeClockingSettings).hashCode = function () {
  var result = this.ia2_1.hashCode();
  result = imul(result, 31) + getBooleanHashCode(this.ja2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ka2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.la2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ma2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.na2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.oa2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.pa2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.qa2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ra2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.sa2_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ta2_1) | 0;
  result = imul(result, 31) + (this.ua2_1 == null ? 0 : getStringHashCode(this.ua2_1)) | 0;
  result = imul(result, 31) + (this.va2_1 == null ? 0 : this.va2_1.hashCode()) | 0;
  return result;
};
protoOf(TimeClockingSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TimeClockingSettings))
    return false;
  var tmp0_other_with_cast = other instanceof TimeClockingSettings ? other : THROW_CCE();
  if (!this.ia2_1.equals(tmp0_other_with_cast.ia2_1))
    return false;
  if (!(this.ja2_1 === tmp0_other_with_cast.ja2_1))
    return false;
  if (!(this.ka2_1 === tmp0_other_with_cast.ka2_1))
    return false;
  if (!(this.la2_1 === tmp0_other_with_cast.la2_1))
    return false;
  if (!(this.ma2_1 === tmp0_other_with_cast.ma2_1))
    return false;
  if (!(this.na2_1 === tmp0_other_with_cast.na2_1))
    return false;
  if (!(this.oa2_1 === tmp0_other_with_cast.oa2_1))
    return false;
  if (!(this.pa2_1 === tmp0_other_with_cast.pa2_1))
    return false;
  if (!(this.qa2_1 === tmp0_other_with_cast.qa2_1))
    return false;
  if (!(this.ra2_1 === tmp0_other_with_cast.ra2_1))
    return false;
  if (!(this.sa2_1 === tmp0_other_with_cast.sa2_1))
    return false;
  if (!(this.ta2_1 === tmp0_other_with_cast.ta2_1))
    return false;
  if (!(this.ua2_1 == tmp0_other_with_cast.ua2_1))
    return false;
  if (!equals(this.va2_1, tmp0_other_with_cast.va2_1))
    return false;
  return true;
};
function ITimeClockingSettingsMutator() {
}
//region block: exports
export {
  get_timeClockingModule as get_timeClockingModule34v5wf1ghe8ph,
  ITimeClockingSettingsAccessor as ITimeClockingSettingsAccessor19mcc5974omlh,
  ITimeClockingSettingsMutator as ITimeClockingSettingsMutatorquo3ktfkxadg,
};
//endregion

